// Fetch categories from the API
import instance from "../../utils/axios";

export const endCategoryTime = async (categoryID, activityId) => {
  try {
    if (!activityId) {
      throw new Error("Activity Id is required.");
    }
    if (!categoryID) {
      throw new Error("Category ID is required.");
    }
    return await instance.get(
      `/end-time-in-category/${encodeURIComponent(
        categoryID
      )}/${encodeURIComponent(activityId)}`
    );
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};
